import { useSelector, useStore } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useRef } from 'react'

import LandingZoneGroupsApi from '../../api/landingZones/groups'

import * as landingZoneGroupsMapping from '../../store/actions/landingZoneGroups'
import * as landingZoneGroupsMappingType from '../../store/actions/landingZoneGroups/types'

import { useNavigate } from 'react-router-dom'
import { useAppSnackbar } from '@services/hooks/AppSnackbar'
import { useAppLoader } from '@services/hooks/AppLoader'
import { useApiError } from '@services/hooks/ApiError'

import { createId } from '@services/utils'
import { generateUrl } from '@services/routes'
import { ROUTE_LANDING_ZONES } from '@features/routes'

import { CONTEXT, useLandingZones } from '@features/hooks/LandingZones'
import { useLandingZoneMembership } from '@features/hooks/LandingZones/membership'

export const useLandingZoneGroups = () => {
    const store = useStore()
    const dataStore = useSelector(state => state.landingZoneGroups)
    const landingZoneGroupsAction = bindActionCreators(landingZoneGroupsMapping, store.dispatch)

    const { formatMembership } = useLandingZoneMembership()
    const { inLandingZones, getProvider, getRobotData } = useLandingZones()
    const { hide: hideLoader, show: showLoader } = useAppLoader()
    const { handleError: apiError } = useApiError()
    const { show: showSnack } = useAppSnackbar()
    const navigate = useNavigate()

    const loaderCallback = useRef(null)

    const getData = (index = null) => {
        if (!index) return store.getState().landingZoneGroups
        return store.getState().landingZoneGroups[index]
    }

    const getGroups = async (id, context) => {
        try {
            const allGroups = await getRobotData(id, context, {
                endpoint: '/api/groups',
                apiLoader: LandingZoneGroupsApi,
                queryParams: { withMembers: 'true', withOwners: 'true' }
            })

            landingZoneGroupsAction.populate(allGroups, () => {
                landingZoneGroupsAction.setLoaded(id, format)
            })
        } catch (error) { apiError(error) }
    }

    const format = () => {
        const raw = getData()
        const grid = []

        for (let i = 0; i < raw.data.length; i++) {
            const item = raw.data[i]
            grid.push({
                id: createId(),
                name: item.displayName ?? '-',
                objectId: item.id ?? '-',
                type: item.type ?? '-',
                link: item.url ?? '-',
                mailNickname: item.mailNickname ?? '-',
                data: formatMembership(item)
            })
        }

        landingZoneGroupsAction.setFormat(grid, landingZoneGroupsMappingType.SET_FORMAT, hideLoader)
    }

    const load = (id, callback = null) => {
        loaderCallback.current = callback

        if (dataStore.loaded === id) return

        landingZoneGroupsAction.setFormat([], landingZoneGroupsMappingType.SET_FORMAT, () => {
            if (!inLandingZones(id, false)) {
                hideLoader()
                showSnack(`Unknown landing zone`)
                return navigate(generateUrl(ROUTE_LANDING_ZONES))
            }

            showLoader(` `)

            const provider = getProvider(id)
            getGroups(id, CONTEXT[provider])
        })
    }

    return { load }
}